<template>
    <div class="flex flex-col gap-3 rounded-2xl border border-border bg-surface-raised px-5 py-4 md:flex-row md:items-center md:gap-4">
        <div class="flex-1 min-w-0">
            <p class="body-small-semibold text-ink">Do you lead a team?</p>
            <p class="body-small text-ink-muted">Managers can track goals for themselves and for their team members</p>
        </div>
        <div class="flex items-center justify-end gap-4 md:shrink-0">
            <BaseRadioGroup v-model="selectedValue" :options="managerOptions" orientation="horizontal" aria-label="Do you lead a team?" :disabled="isSubmitting" />
            <BaseButton theme="secondary" size="sm" class="shrink-0" :disabled="!selectedValue || isSubmitting" @click="handleConfirm">
                {{ isSubmitting ? "Saving…" : "Confirm" }}
            </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useFetch } from "~vue/api";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseRadioGroup from "~vue/components/form/BaseRadioGroup.vue";
import { computed, onMounted, ref } from "vue";

import { JourneysAmplitudeEventNames, logJourneysUserInteraction } from "./utils";

const emit = defineEmits<{ confirmed: [isManager: boolean] }>();

const selectedValue = ref<"yes" | "no" | null>(null);
const managerOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
];
const isSubmitting = ref(false);

onMounted(() => {
    logJourneysUserInteraction(JourneysAmplitudeEventNames.MANAGER_BANNER_SHOWN);
});

const { execute: saveManagerStatus } = useFetch("/api/accounts/user", { immediate: false })
    .put(computed(() => ({ is_manager: selectedValue.value === "yes" })))
    .json();

async function handleConfirm() {
    if (!selectedValue.value || isSubmitting.value) {
        return;
    }
    isSubmitting.value = true;
    const isManager = selectedValue.value === "yes";
    await saveManagerStatus();
    isSubmitting.value = false;
    logJourneysUserInteraction(JourneysAmplitudeEventNames.MANAGER_BANNER_SUBMITTED, { is_manager: isManager });
    emit("confirmed", isManager);
}
</script>
